import { Component, inject, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'yes-no',
  imports: [],
  templateUrl: './yes-no.component.html',
  styleUrl: './yes-no.component.scss'
})
export class YesNoComponent implements OnInit {
  #modalService = inject(BsModalService)

  title: string
  acceptBtnTitle: string
  abortBtnTitle: string
  description: string
  closeAvailable: boolean = true

  public onClose: Subject<boolean | null> = new Subject<boolean | null>();

  ngOnInit(): void {
      this.title = this.#modalService['initialState']?.title || ''
      this.acceptBtnTitle = this.#modalService['initialState']?.acceptBtnTitle || undefined
      this.abortBtnTitle = this.#modalService['initialState']?.abortBtnTitle || undefined
      this.description = this.#modalService['initialState']?.description || ''
      this.closeAvailable = this.#modalService['initialState']?.closeAvailable || true
  }

  accept() {
      this.onClose.next(true);
      this.onClose.complete();
  }

  abort() {
      this.onClose.next(false);
      this.onClose.complete();
  }

  close() {
      if (this.closeAvailable) {
          this.onClose.next(null);
          this.onClose.complete();
      }
  }
}
